/**
 * Zeus — Riders rail
 * IntersectionObserver → active card only (watermark stays fixed)
 * Pointer drag → horizontal scroll (desktop)
 */
(function () {
  function initRail(root) {
    if (!root || root.dataset.zrrReady === "true") return;
    root.dataset.zrrReady = "true";

    var rail = root.querySelector("[data-zrr-rail]");
    if (!rail) return;

    var stage = root.querySelector("[data-zrr-stage]");
    var scrollHint = root.querySelector("[data-zrr-scroll-hint]");
    var cards = Array.prototype.slice.call(rail.querySelectorAll("[data-zrr-card]"));
    if (!cards.length) return;

    function prefersReducedMotion() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    function getScrollStep() {
      var card = cards[0];
      if (!card) return Math.max(rail.clientWidth * 0.8, 1);
      var gap = parseInt(window.getComputedStyle(rail).gap, 10) || 0;
      return card.offsetWidth + gap;
    }

    function updateScrollHint() {
      if (!scrollHint || !stage) return;

      var maxScroll = rail.scrollWidth - rail.clientWidth;
      var canScroll = maxScroll > 10;
      var atEnd = rail.scrollLeft >= maxScroll - 10;

      stage.classList.toggle("is-at-end", atEnd);
      stage.classList.toggle("is-scroll-hint-hidden", !canScroll || atEnd);

      if (!canScroll || atEnd) {
        scrollHint.hidden = true;
        scrollHint.classList.remove("is-visible");
        scrollHint.classList.add("is-hidden");
        return;
      }

      scrollHint.hidden = false;
      scrollHint.classList.add("is-visible");
      scrollHint.classList.remove("is-hidden");
    }

    if (scrollHint) {
      scrollHint.addEventListener("click", function () {
        rail.scrollBy({
          left: getScrollStep(),
          behavior: prefersReducedMotion() ? "auto" : "smooth",
        });
      });

      rail.addEventListener("scroll", updateScrollHint, { passive: true });
      window.addEventListener("resize", updateScrollHint, { passive: true });
      updateScrollHint();
    }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          var visible = entries
            .filter(function (e) {
              return e.isIntersecting;
            })
            .sort(function (a, b) {
              return b.intersectionRatio - a.intersectionRatio;
            });
          if (!visible.length) return;
          var best = visible[0].target;
          cards.forEach(function (c) {
            c.classList.toggle("is-active", c === best);
          });
        },
        {
          root: rail,
          threshold: [0.35, 0.5, 0.65, 0.8],
        },
      );
      cards.forEach(function (c) {
        io.observe(c);
      });
    }

    var down = false;
    var startX = 0;
    var scrollLeft = 0;
    var moved = false;

    rail.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "touch") return;
      down = true;
      moved = false;
      startX = e.clientX;
      scrollLeft = rail.scrollLeft;
      try {
        rail.setPointerCapture(e.pointerId);
      } catch (err) {
        /* ignore */
      }
    });

    rail.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      rail.scrollLeft = scrollLeft - dx;
    });

    function endDrag() {
      down = false;
    }

    rail.addEventListener("pointerup", endDrag);
    rail.addEventListener("pointercancel", endDrag);

    /* Prevent accidental click after drag */
    rail.addEventListener(
      "click",
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true,
    );
  }

  function boot() {
    document.querySelectorAll("[data-zeus-riders-rail]").forEach(initRail);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target && e.target.querySelector("[data-zeus-riders-rail]");
    if (root) {
      root.dataset.zrrReady = "";
      initRail(root);
    }
  });
})();
